export default [
    'Corporate',
    'Franchisee',
    'LLC',
    'Personal',
    'Other'
];